(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customstyle-benefits"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-customstyle-benefits]').forEach((section) => {
    if (section.dataset.ready === 'true') return;
    section.dataset.ready = 'true';
    const track = section.querySelector('[data-benefits-track]');
    const originals = [...track.children];
    originals.forEach((item) => { const clone=item.cloneNode(true); clone.setAttribute('aria-hidden','true'); track.appendChild(clone); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customstyle-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-customstyle-testimonials]').forEach((section) => {
    if (section.dataset.ready === 'true') return;
    section.dataset.ready = 'true';
    const viewport = section.querySelector('[data-testimonial-viewport]');
    const amount = () => (viewport.querySelector('.customstyle-testimonial')?.getBoundingClientRect().width || viewport.clientWidth) + 16;
    section.querySelector('[data-testimonial-prev]')?.addEventListener('click', () => viewport.scrollBy({ left: -amount(), behavior: 'smooth' }));
    section.querySelector('[data-testimonial-next]')?.addEventListener('click', () => viewport.scrollBy({ left: amount(), behavior: 'smooth' }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
